/**
 * The address parts this renderer reads. Every part is optional: callers hand
 * it list rows, detail rows and global-search hits, and the renderer drops
 * falsy parts anyway. Declared structurally rather than Picked off
 * `PlaceDetailType` so it does not drag that DTO's non-null `address1` along —
 * a leaner source could never satisfy it, which is what forced the `as any` /
 * `as PlaceAddress` casts at several call sites.
 */
export type PlaceAddress = {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
};

export const renderPlaceAddress = (
  place?: PlaceAddress,
  options?: string[],
) => {
  if (!place) return "";
  // Default display short address
  let address = [place?.address1, place?.address2].filter(Boolean); // remove null data
  if (options && options.length !== 0) {
    // Custom display
    address = options
      .map((key) => place?.[key as keyof typeof place])
      .filter(Boolean);
  }
  return address.join(", ");
};
